<template>
  <v-select
      v-model="themeSelected"
      :items="themes"
      item-value="title"
      item-text="title"
      v-bind:label="$t('theme.selectPlaceholder')"
      solo
      clearable
      background-color="#f5b83e"
      return-object
  >

    <template slot="selection" slot-scope="data">
      {{ data.item.title }}
      <v-chip v-if="data.item.isNew" style="position: absolute; right:15%" color="#e4087e" text-color="white" small>NEW</v-chip>
    </template>
    <template slot="item" slot-scope="data">
      {{ data.item.title }}
      <v-chip v-if="data.item.isNew" style="position: absolute; right:5%" color="#e4087e" text-color="white" small>NEW</v-chip>
    </template>
  </v-select>
</template>

<script>
import Api from "@/core/services/api.service";
import userParentThemes from "@/core/utils/userParentThemes";
import {userLastTheme} from '@/core/utils/theme';
import {mapGetters} from "vuex";

export default {
  name: "themeSelect",
  data: () => ({
    themeSelected: null,
    themes: []
  }),
  props: {
    themeId: Number,
  },
  mounted() {
    // Au chargement du select, appel de l'API pour récupérer la liste des thèmes
    Api.get("themes").then(themes => {
      this.themes = userParentThemes(themes.data["hydra:member"]);
      for(var i = 0; i < this.themes.length; i++){
        this.themes[i].isNew = userLastTheme(this.currentUser, this.themes[i]);
      }
      this.themeSelected = this.themes.find(t => t.id === this.themeId)
    });
  },
  watch: {
    themeSelected: function (newThemeSelected) {
      if (typeof newThemeSelected === 'undefined') {
        newThemeSelected = null;
      }
      this.$emit("selection-change", newThemeSelected);
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
  }
};
</script>
